/**
 * @file 贡献指南 入口
 * @author WanZhongYun(wanzhongyun@baidu.com)
 */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'location-origin';
import 'element-qsa-scope';
import React from 'react';
import ReactDOM from 'react-dom';
import DocRoute from './ContributionRouter';

import './style/style.less';

ReactDOM.render(<DocRoute />, document.getElementById('root'));